module.exports = __webpack_public_path__ + "static/media/flr-nsw-glam.fccdecf9.png";